import { baseApi, type MoneyDto } from '@shared/api/baseApi';

export type DepositStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface DepositDto {
  id: string;
  amount: MoneyDto;
  status: DepositStatus;
  createdAt: string;
  reviewedAt: string | null;
  amountPending: boolean;
}

export interface PaymentMethodDto {
  id: string;
  name: string;
  accountNumber: string;
  accountName: string;
  logoUrl: string;
}

export interface DepositsResponse {
  deposits: DepositDto[];
  paymentMethods: PaymentMethodDto[];
}

export const depositApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeposits: builder.query<DepositsResponse, void>({
      query: () => '/deposits',
      providesTags: ['Deposit'],
    }),
    requestDeposit: builder.mutation<
      {
        mode: 'automatic' | 'manual';
        deposit: DepositDto;
        balance?: MoneyDto;
        duplicate?: boolean;
      },
      { receiptBase64?: string; receiptText?: string }
    >({
      query: (body) => ({ url: '/deposits', method: 'POST', body }),
      invalidatesTags: ['Deposit', 'User'],
    }),
  }),
});

export const { useGetDepositsQuery, useRequestDepositMutation } = depositApi;
